/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";
import Actions from "../../../../../fluid/Actions/ActionFactory";
import { Tooltip, Typography, Paper } from "@material-ui/core";


class TextFileViewer extends Component {
  componentDidMount() {
    console.log("Text File URL : ", this.props.url);
    let textFileURL = this.props.url;
    if (window.File && window.FileReader && window.FileList && window.Blob) {
      Actions("http_request", {
        url: `${textFileURL}`,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          let textContent = response.data;
          let textContainer = document.getElementById("text-viewer-container");
          let reader = new FileReader();

          reader.onload = function (event) {
            let contents = event.target.result;
            textContainer.innerText = contents;
          };

          reader.readAsText(textContent);
        })
        .catch((err) => {
          console.log("error while fetching text file", err);
        });
    } else {
      alert("Your browser is too old to support HTML5 File API");
    }
  }
  renderToolbar = () => {
    return (
      <Paper
        style={{
          width: "100%",
          height: "50px",
          backgroundColor: "#FFFFFF",
          padding: "5px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
        square
        elevation={4}
      >
        {" "}
        <Tooltip title={this.props.file_name}>
          <Typography
            style={{
              width: "20%",
              flexGrow: 1,
            }}
            variant="overline"
            noWrap={true}
          >
            {this.props.file_name}
          </Typography>
        </Tooltip>
      </Paper>
    );
  };
  render() {
    return (
      <>
      {this.renderToolbar()}      
      <pre
        style={{
          padding:"5px 0 0 5px",
          boxSizing:"content-box",
          height:parseInt(this.props.height) - 50,
          whiteSpace: "pre-wrap",
        }}
        id="text-viewer-container"
      ></pre>      
      </>
    );
  }
}

export default TextFileViewer;
